import { post } from '@/utils/xhr'

class FCM {
  SYNC = (token: string) => {
    return post('/fcm', { token })
  }
}
export const FCMService = new FCM()
